import * as actionTypes from 'actions';

const initialState = {
  saved: false,
  savedIntegrationPartner: {},
  deleted: false,
  deletedIntegrationPartner: {},
  integrationPartner: {
    name: '',
    website: '',
    apiClientIds: []
  },
  validationMessages: {},
  saving: false
};

const integrationPartnerCreateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_INTEGRATION_PARTNER_PENDING: {
      return {
        ...state,
        saving: true
      };
    }

    case actionTypes.SAVE_INTEGRATION_PARTNER_FULFILLED: {
      return {
        ...state,
        saved: action.payload.data.success,
        savedIntegrationPartner: action.payload.data.result,
        validationMessages: action.payload.data.validationMessages,
        saving: false
      };
    }

    case actionTypes.DELETE_INTEGRATION_PARTNER_FULFILLED: {
      return {
        ...state,
        deleted: action.payload.data.success,
        deletedIntegrationPartner: action.payload.data.result
      };
    }

    case actionTypes.EDIT_INTEGRATION_PARTNER_FULFILLED: {
      return {
        ...state,
        integrationPartner: action.payload.data.result
      };
    }

    case actionTypes.CREATE_INTEGRATION_PARTNER_VALUE_RESET: {
      return {
        ...initialState
      };
    }

    case actionTypes.CREATE_INTEGRATION_PARTNER_VALUE_UPDATE: {
      return {
        ...state,
        integrationPartner: {
          ...state.integrationPartner,
          ...action.payload
        }
      };
    }

    case actionTypes.ADD_INTEGRATION_PARTNER_API_CLIENT_ID: {
      const apiClientIds = state.integrationPartner.apiClientIds
        ? state.integrationPartner.apiClientIds.slice()
        : [];
      apiClientIds.push('');
      return {
        ...state,
        integrationPartner: {
          ...state.integrationPartner,
          apiClientIds
        }
      };
    }

    case actionTypes.REMOVE_INTEGRATION_PARTNER_API_CLIENT_ID: {
      const apiClientIds = state.integrationPartner.apiClientIds.slice();
      apiClientIds.splice(action.payload, 1);
      return {
        ...state,
        integrationPartner: {
          ...state.integrationPartner,
          apiClientIds
        }
      };
    }

    case actionTypes.SET_INTEGRATION_PARTNER_API_CLIENT_ID_VALUE: {
      const apiClientIds = state.integrationPartner.apiClientIds.slice();
      const { value, index } = action.payload;
      apiClientIds[index] = value;
      return {
        ...state,
        integrationPartner: {
          ...state.integrationPartner,
          apiClientIds
        }
      };
    }

    default: {
      return state;
    }
  }
};

export default integrationPartnerCreateReducer;
